import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import imageWooflashLogo from 'images/logos/logo.svg';

import BACKGROUND_SMALL from './images/bg-small.svg';
import ELEPHANT_IMAGE_SMALL from './images/elephant-small.svg';
import LanguageSelector from './LanguageSelector';
import styles from './Container.module.scss';

const cx = classNames.bind(styles);

const Container = ({ action, children, isDark, sideImage, t }) => (
  <div className={cx('container', { isDark })}>
    <aside
      className={cx('side')}
      style={{
        backgroundImage: `url(${sideImage})`,
      }}
    >
      {/* Desktop */}
      <Link
        aria-label={t('Auth/Shared/Container/aria-home')}
        className={cx('logo')}
        to="/"
      >
        <img
          alt=""
          aria-hidden="true"
          className={cx('logo-image')}
          src={imageWooflashLogo}
        />
        <span className={cx('logo-text')}>wooflash</span>
      </Link>
      <div className={cx('filler-1')} />
      <p className={cx('side-text-large')}>
        {t('Auth/Shared/Container/side-text')}
      </p>
      <div className={cx('filler-2')} />
      {/* Mobile */}
      <p className={cx('side-text-small')}>wooflash</p>
      <img
        alt=""
        aria-hidden="true"
        className={cx('elephant-small')}
        src={ELEPHANT_IMAGE_SMALL}
      />
      <img
        alt=""
        aria-hidden="true"
        className={cx('bg-small')}
        src={BACKGROUND_SMALL}
      />
    </aside>
    <header className={cx('header')}>
      {action && <div className={cx('header-action')}>{action}</div>}
      <LanguageSelector />
    </header>
    <main className={cx('main')}>
      <div className={cx('content')}>{children}</div>
    </main>
  </div>
);

Container.propTypes = {
  action: PropTypes.node,
  children: PropTypes.node.isRequired,
  isDark: PropTypes.bool,
  sideImage: PropTypes.node,
  t: PropTypes.func.isRequired,
};

Container.defaultProps = {
  action: undefined,
  isDark: false,
  sideImage: undefined,
};

export default Container;
